import {
  Button,
  Popover,
  PopoverSurface,
  PopoverTrigger,
  Tooltip,
} from "@fluentui/react-components";
import { useBoolean } from "@fluentui/react-hooks";
import { InfoRegular, SettingsFilled } from "@fluentui/react-icons";
import React from "react";
import { Link } from "react-router-dom";
import { StatusIconSelector } from "../../../components-v2/common/icon-selectors/StatusIconSelector";
import { $sky60 } from "../../../cssjs/colors";
import { FlightCardTypes } from "../../../enum/flights/FlightEnum";
import PageEnum from "../../../enum/PageEnum";
import { CommonHelper } from "../../../utils/common/CommonHelper";
import { KpiToolTipInfo } from "./KpiToolTipInfo";

interface IFlightKpiCardHeaderProps {
  label: string;
  cardName: FlightCardTypes;
  overall: any;
  showSettings?: boolean;
  showInformation?: boolean;
  hasError: boolean;
  airport: string;
  cardBuffer: any;
  kpiCalulcationTextContent: React.ReactNode;
}

export const FlightKpiCardHeader: React.FC<IFlightKpiCardHeaderProps> = ({
  label,
  cardName,
  overall,
  showSettings,
  showInformation,
  hasError,
  airport,
  cardBuffer,
  kpiCalulcationTextContent,
}) => {
  const [isInfoVisible, { toggle: toggleIsInfoCalloutVisible }] =
    useBoolean(false);
  const isInTeams = CommonHelper.isInTeams();

  const appSettingsLinkContent = isInTeams ? (
    <Link
      to={`/${PageEnum.PageUrl.ApplicationSettings}`}
      aria-label="Application Settings"
    >
      <SettingsFilled
        style={{ fontSize: "16px", color: $sky60 }}
        data-testid="link-to-settings"
      />
    </Link>
  ) : (
    <Link
      to={`/${
        PageEnum.PageUrl.ApplicationSettings
      }?airport=${encodeURIComponent(airport)}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "inherit", textDecoration: "none" }}
      aria-label="Application Settings"
    >
      <SettingsFilled
        style={{ fontSize: "16px", color: $sky60 }}
        data-testid="link-to-settings"
      />
    </Link>
  );

  return (
    <header className="fs-18 fw-700 d-flex amd-container-hspacebtwn ai-center">
      <div className="d-flex gap-5">
        {`${label} ${
          cardName === FlightCardTypes.ADDITIONAL_DELAY
            ? `${Math.round(overall?.kpiValue || 0)} min`
            : `${Math.round(overall?.kpiValue || 0)}%`
        }`}
        <StatusIconSelector status={overall?.status} />
      </div>

      <div
        className="d-flex ai-center"
        style={{ cursor: "pointer" }}
        onClick={(e) => e.stopPropagation()}
      >
        {showSettings && (
          <Tooltip
            key={CommonHelper.getGuid()}
            withArrow
            content={{
              children: "Application Settings",
            }}
            relationship="description"
          >
            {appSettingsLinkContent}
          </Tooltip>
        )}
        {!hasError && showInformation && (
          <Popover
            open={isInfoVisible}
            onOpenChange={toggleIsInfoCalloutVisible}
            positioning="below-end"
          >
            <PopoverTrigger>
              <Button
                aria-label="More information"
                style={{
                  border: "none",
                  background: "transparent",
                  padding: 0,
                }}
                data-testid="info-button"
                onClick={() => toggleIsInfoCalloutVisible}
                icon={
                  <InfoRegular
                    style={{
                      fontSize: "18px",
                      color: $sky60,
                    }}
                  />
                }
                iconPosition="after"
              />
            </PopoverTrigger>
            <PopoverSurface>
              <div style={{ maxWidth: "250px" }}>
                <KpiToolTipInfo Buffers={cardBuffer} bufferName={cardName} />
                <br />
                {kpiCalulcationTextContent}
              </div>
            </PopoverSurface>
          </Popover>
        )}
      </div>
    </header>
  );
};
